import React from 'react';
import {Button, Col, Modal, ModalHeader, ModalBody, Row} from 'reactstrap';
import {Link} from 'react-scroll';
import classNames from 'classnames';
import useExitIntent from 'utils/useExitIntent.js';
import {OptinModalTrigger} from 'components/OptinModal';
import './Modal.scss';

export default function WiredModal({children, isOpen, toggle, ...props}) {
  return (
    <Modal isOpen={isOpen} toggle={toggle} returnFocusAfterClose={false} {...props}>
      <ModalHeader toggle={toggle} />
      <ModalBody>{children}</ModalBody>
    </Modal>
  );
}
